import Phaser from '../lib/phaser.js';

/**
 * @param {Phaser.Scene} scene
 * @param {object} [options]
 * @param {() => void} [options.callback]
 * @param {boolean} [options.skipSceneTransition=false]
 */
export function createSceneTransition(scene, options) {
  const skipSceneTransition = options?.skipSceneTransition || false;
  if (skipSceneTransition) {
    if (options?.callback) {
      options.callback();
    }
    return;
  }

  // Size + center the wipe to the camera's WORLD view (not the raw viewport): the battle scene
  // zooms/scrolls its camera to cover the window, so a viewport-sized mask in world space would be
  // mis-centered. Compute the world-space view from zoom + scroll directly (set synchronously by
  // the camera fit) to avoid relying on worldView, which only refreshes on the next render.
  const cam = scene.cameras.main;
  const zoom = cam.zoom || 1;
  const left = cam.scrollX;
  const top = cam.scrollY;
  const width = cam.width / zoom;
  const height = cam.height / zoom;
  const centerY = top + height / 2;
  const rectShape = new Phaser.Geom.Rectangle(left, centerY, width, 0);
  const g = scene.add.graphics().fillRectShape(rectShape).setDepth(-1);
  const mask = g.createGeometryMask();
  scene.cameras.main.setMask(mask);

  scene.tweens.add({
    onUpdate: () => {
      g.clear().fillRectShape(rectShape);
    },
    delay: 400,
    duration: 800,
    height: {
      ease: Phaser.Math.Easing.Expo.InOut,
      from: 0,
      start: 0,
      to: height,
    },
    y: {
      ease: Phaser.Math.Easing.Expo.InOut,
      from: centerY,
      start: centerY,
      to: top,
    },
    targets: rectShape,
    onComplete: () => {
      mask.destroy();
      // destroy the backing Graphics too, otherwise each transition leaks a Graphics object
      g.destroy();
      scene.cameras.main.clearMask();
      if (options?.callback) {
        options.callback();
      }
    },
  });
}
